import { styled } from '@mui/material';

export const SvgContainer = styled('svg')();
